module.exports = __webpack_public_path__ + "img/AR721.0868e793.png";